import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Footer from './components/Footer';
import MapaUnidades from './components/MapaUnidades';
import Login from './components/Login';
import ValidarCredenciais from './components/ValidarCredenciais';

const HomePage: React.FC = () => {
  const [currentView, setCurrentView] = useState<'home' | 'mapa'>('home');

  const showMapa = () => {
    setCurrentView('mapa');
  };

  const showHome = () => {
    setCurrentView('home');
  };

  const scrollToServicos = () => {
    const servicosSection = document.getElementById('servicos');
    if (servicosSection) {
      servicosSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  if (currentView === 'mapa') {
    return (
      <div className="App">
        <MapaUnidades onVoltar={showHome} />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero onMapaClick={showMapa} onServicosClick={scrollToServicos} />
      <Services />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/validar-credenciais" element={<ValidarCredenciais />} />
    </Routes>
  );
}

export default App;
